<template>
  <div class="TalkingIdol">
    <LottieAnimation v-show="selectedIdx === 0"
      :animationData="require('@/assets/image/ai/AI_talk_Idle.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
    <LottieAnimation v-show="selectedIdx === 1"
      :animationData="require('@/assets/image/ai/AI_talk_Hello.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
    <LottieAnimation v-show="selectedIdx === 2"
      :animationData="require('@/assets/image/ai/AI_talk_talk.json')"
      :loop="true"
      :auto-play="true"
      :speed="1" />
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
export default {
  name: 'TalkingIdol',
  components: {
    LottieAnimation
  },
  props: {
    selectedIdx: {
      type: Number,
      default: 0
    }
  },
  setup() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.TalkingIdol {
  width: 300px;
  @media (min-width: 1440px) {
    width: 400px;
  }
}
</style>
